export const generateImageUrl = (url: string, index: number) => {
  return url.replace('{cnt}', String(index + 1));
};

export const generateMetaDataImageUrl = (url: string) => {
  return url.replace('{cnt}', '1').replace('{res}', '840');
};
